import { useState } from "react";
import { IonHeader, IonInput, IonItem, IonLabel } from "@ionic/react";
import msg from "components/string-table";
import { Colors, ErrorAlert, Icon } from "main";

import styles from "./PasswordField.module.css";

type PasswordFieldProps = {
  error?: string;
  passwordLabel: string;
  onPasswordInput: (e: string) => void;
  password: string;
};

export function PasswordField(props: PasswordFieldProps) {
  const { passwordLabel, onPasswordInput, error, password } = props;
  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <div style={{ width: "inherit" }}>
      {/* Adds styling to off-set Ionic's Legacy padding */}
      <IonHeader className="ion-padding-start ion-no-border">
        <IonLabel style={{ fontWeight: "var(--swing-font-medium)" }}>{passwordLabel}</IonLabel>
      </IonHeader>
      <IonItem
        lines="full"
        className={`${styles.backgroundGray} ${error ? styles.inputError : ""}`}
        css={{
          width: "100%",
          "--border-color": Colors.slate400,
          "--min-height": "auto",
        }}
      >
        <IonInput
          data-testid="password-input"
          type={showPassword ? "text" : "password"}
          value={password}
          onIonInput={(e) => onPasswordInput(e.detail.value || "")}
          spellCheck="false"
          aria-label={passwordLabel}
          clearOnEdit={false}
        />
        <DisplayPasswordButton
          showPassword={showPassword}
          onShowPassword={(value: boolean) => setShowPassword(value)}
        />
      </IonItem>
      {error && <IncorrectPassword error={error} />}
    </div>
  );
}

type IncorrectPasswordProps = {
  error?: string;
};

const IncorrectPassword: React.FC<IncorrectPasswordProps> = ({ error }) => (
  <ErrorAlert customStyles={{ fontSize: 14 }}>
    <span>{error}</span>
  </ErrorAlert>
);

type DisplayButtonProps = {
  showPassword: boolean;
  onShowPassword: (e: boolean) => void;
};
function DisplayPasswordButton(props: DisplayButtonProps) {
  const { showPassword, onShowPassword } = props;
  const label = showPassword
    ? msg("PASSWORD_FIELD_LOGIN_PASSWORD_HIDE_LABEL")
    : msg("PASSWORD_FIELD_LOGIN_PASSWORD_SHOW_LABEL");
  const ariaLabel = showPassword
    ? msg("PASSWORD_FIELD_LOGIN_PASSWORD_ARIA_HIDE_LABEL")
    : msg("PASSWORD_FIELD_LOGIN_PASSWORD_ARIA_SHOW_LABEL");
  return (
    <button
      type="button"
      onClick={() => onShowPassword(!showPassword)}
      aria-pressed={showPassword}
      aria-label={ariaLabel}
      className={styles.passwordToggle}
    >
      {showPassword ? (
        <Icon name="Eye Off" color={Colors.blue500} />
      ) : (
        <Icon name="Eye On" color={Colors.blue500} />
      )}
      <span
        className={`${styles["icon-tooltip"]} ${styles.showLabel}`}
        style={{ fontWeight: "var(--swing-font-medium)" }}
      >
        {label}
      </span>
    </button>
  );
}
